// Хранилище токенов. Каркас: localStorage. При ужесточении безопасности
// перевести refresh в httpOnly-cookie (отдаёт backend), access держать в памяти.

const ACCESS_KEY = 'expertview.access';
const REFRESH_KEY = 'expertview.refresh';

export const tokenStore = {
  getAccess(): string | null {
    return localStorage.getItem(ACCESS_KEY);
  },
  getRefresh(): string | null {
    return localStorage.getItem(REFRESH_KEY);
  },
  set(access: string, refresh: string): void {
    localStorage.setItem(ACCESS_KEY, access);
    localStorage.setItem(REFRESH_KEY, refresh);
  },
  clear(): void {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
  },
};
